import HomeIcon from "@mui/icons-material/Home";
import PersonIcon from "@mui/icons-material/Person";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import VaccinesIcon from "@mui/icons-material/Vaccines";
import DrawIcon from "@mui/icons-material/Draw";
import ContactPageIcon from "@mui/icons-material/ContactPage";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import FormatAlignJustifyIcon from "@mui/icons-material/FormatAlignJustify";
export const navData = [
  {
    id: 0,
    icon: <HomeIcon />,
    text: "Dashboard",
    link: "/dashboard",
    role: ["admin"],
  },
  {
    id: 1,
    icon: <PersonIcon />,
    text: "User Management",
    link: "/user-management",
    role: ["admin"],
  },
  {
    id: 2,
    icon: <VaccinesIcon />,
    text: "Dossier",
    link: "/dossier-management",
    role: ["admin"],
  },
  {
    id: 3,
    icon: <AppRegistrationIcon />,
    text: "Supplier",
    link: "/supplier-management",
    role: ["admin"],
  },
  {
    id: 4,
    icon: <DrawIcon />,
    text: "Blog",
    link: "/blog-management",
    role: ["admin"],
  },
  {
    id: 5,
    icon: <ContactPageIcon />,
    text: "Contact",
    link: "/contact-management",
    role: ["admin"],
  },
  {
    id: 6,
    icon: <NewspaperIcon />,
    text: "Dossier Termsheet",
    link: "/dossier-termsheet-management",
    role: ["admin"],
  },
  {
    id: 7,
    icon: <FormatAlignJustifyIcon />,
    text: "Supplier Termsheet",
    link: "/supplier-termsheet-management",
    role: ["admin"],
  },
];
